import React, {useEffect, useRef, useState} from "react";
import {useHistory} from 'react-router-dom';
import {Form, Formik} from "formik";
import {useUI} from "../../app/context/ui";
import * as Yup from "yup";
import Papa from 'papaparse';
import store from "../../redux/store";
import {Box, Button, Container, Grid, TextField, Typography,} from "../../components/shared/MaterialUI";
import {Alert, AlertTitle} from '@material-ui/lab';
import {CreatePaymentStyles} from "../../assets/css/create-payment-style";
import PaymentService from "../../services/PaymentService";

const CreatePayment = () => {

  const [hasError, setHasError] = useState({message: ''});
  const [requestFailed, setRequestFailed] = useState(false);
  const initialValues = {
    file: ''
  };
  const [file, setFile] = useState({
    file: null,
    name: '',
    records: null
  });
  const [fileValidationResult, setFileValidationResult] = useState({
    message: '',
    rowsEmpty: '',
    cardsEmpty: '',
    priceEmpty: ''
  });
  const divUploadFile = useRef();
  const divResultProcessPayment = useRef();
  const [resultProcessPayment, setResultProcessPayment] = useState({message:''});

  const { blockUI } = useUI();
  const history = useHistory();
  const state = store.getState();

  const accessToken = state.user.accessToken;
  if (!accessToken) {
    history.push("/login");
  }

  const paymentService = new PaymentService();
  const paymentStyle = CreatePaymentStyles();
  paymentService.init(accessToken);

  useEffect(() => {
    if (!setRequestFailed) {
      setHasError({message: ''});
    }
  }, [requestFailed]);

  const extensionSupported = ['csv', 'txt'];
  const validationSchema = Yup.object({
    file: Yup
      .mixed()
      .required('A file is required')
      .test(
        "fileFormat",
        "Unsupported Format",
        (value) => {
          const ext = getFileExtension(value);
          return ext && extensionSupported.includes(ext)
        }
       ),
  });

  const getFileExtension = (filename) => {
    return filename.split('.').pop();
  }

  let parseCSV = (text) => {
    let lines = text.replace(/\r/g, '').split('\n');
    return lines.map(line => {
      return line.split(',');
    });
  }

  const parseCSV2 = (text) => {
    let temp = text.replace(/\r/g, '');
    let r = Papa.parse(temp, {
      skipEmptyLines: true,
    });

    return r.data;
  };

  const reset = (values) => {
    values.file = '';
    setFileValidationResult({
      message: ''
    });
  };

  const fileSelectHandler = (e) => {
    let file = e.target.files[0];
    let filesSupported = ['text/plain', 'text/csv', 'application/vnd.ms-excel'];
    if (file === undefined || !filesSupported.includes(file?.type)) {
      setFileValidationResult({
        fileNotAllowed: 'The file has to be text/csv'
      });
      setFile({
        file: null,
        name: ''
      });
      return;
    }

    let reader = new FileReader();
    let lines;
    let rowsEmpty = 0;
    let cardsEmpty = '';
    let priceEmpty = '';

    reader.onload = (e) => {
      lines = parseCSV2(e.target.result);
      let linesFinal = [];
      (lines[lines.length-1].length===1) && lines.pop();
      lines.forEach((e,i) => {

        if (e.length === 2 && (e[0]) && (e[1])) {
          setFileValidationResult({
            message: 'Valid file to be processed'
          });
          linesFinal.push(e);
        } else {
          if ((e[0] === '' && e[1] === '') || e.length === 1) {
            rowsEmpty++;
          } else {
            if (e[0] === '') {
              cardsEmpty += e[1] + ', ';
            } else {
              priceEmpty += e[0] + ', ';
            }
          }
        }
      });

      setFile({
        file,
        name: file?.name.slice(0, -4),
        records: linesFinal
      });

      if (rowsEmpty !== 0 || cardsEmpty !== '' || priceEmpty !== '') {
        setFileValidationResult({
          rowsEmpty,
          cardsEmpty,
          priceEmpty
        });
      }
    };
    reader.readAsBinaryString(file);
  }

  const [paymentIdRedirect, setPaymentIdRedirect] = useState()

  const onSubmit = async (values) => {
    try {
      if(file.file){
        blockUI.current.open(true);
        setRequestFailed(false);
        paymentService.init(accessToken);
        paymentService.setHeaderContentType();
        const fd = new FormData();
        fd.append('file', file.file, file.name);
        fd.append('name', file.name.replace(/\s+/g, ''));
        fd.append('records', JSON.stringify(file.records));
        let { data: dataPayment } = await paymentService.upload(fd);
        blockUI.current.open(false);
        setPaymentIdRedirect(dataPayment.idPayment);
        divUploadFile.current.style.display = 'none';
        divResultProcessPayment.current.style.display = 'block';
        (dataPayment.failedRecord) && setResultProcessPayment({ message: 'We\'ve problems to process data, please check CSV file' });
      }
    } catch (e) {
      reset(values);
      setHasError({ message: 'Network error, please try again' });
      blockUI.current.open(false);
      setRequestFailed(true);
    }
  }

  return (
    <Container component="main" maxWidth="lg" className={paymentStyle.ctnInner}>
      <div ref={divUploadFile}>
        <Typography variant="h4">Upload file</Typography>
        <br/>
        <Container maxWidth="lg" className={paymentStyle.ctnUploadFile}>
          <Box pb={2} />
          {requestFailed && (
            <p className={paymentStyle.formError} align="center">{hasError.message}</p>
          )}
          <Box pb={2} />
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              onSubmit(values).then(() => { });
            }}
            enableReinitialize={true}
          >

            {(props) => {
              const {
                values,
                touched,
                errors,
                handleChange,
              } = props;
              return (
                <Form autoComplete="off">
                  <Grid container spacing={3}>
                    <Grid item xs={12} >
                      <label>File *</label>
                    </Grid>
                    <Grid item lg={12} className={paymentStyle.blockInputFile}>
                      <div className="file-select" id="src-file">
                        <TextField
                          className={paymentStyle.inputFile}
                          variant="outlined"
                          autoFocus
                          fullWidth
                          id="file"
                          type="file"
                          name="file"
                          value={values.file}
                          onChange={(e) => { handleChange(e); fileSelectHandler(e); }}
                          error={touched.file && Boolean(errors.file)}
                          helperText={
                            errors.file && touched.file ? errors.file : ""
                          }
                        />
                      </div>
                    </Grid>

                    {
                      (fileValidationResult.message)
                      &&
                      <div className={paymentStyle.alert}>
                        <Alert severity="success">{fileValidationResult.message}</Alert>
                      </div>
                    }

                    {
                      (fileValidationResult.fileNotAllowed)
                      &&
                      <div className={paymentStyle.alert}>
                        <Alert severity="error">{fileValidationResult.fileNotAllowed}</Alert>
                      </div>
                    }

                    {
                      (fileValidationResult.rowsEmpty !== 0 && fileValidationResult.rowsEmpty)
                      &&
                      <div className={paymentStyle.alert}>
                        <Alert severity="error">There are {fileValidationResult.rowsEmpty} empty rows</Alert>
                        <br />
                      </div>
                    }

                    {
                      (fileValidationResult.cardsEmpty)
                      &&
                      <div className={paymentStyle.alert}>
                        <Alert severity="error">Add the account number in the following prices: {fileValidationResult.cardsEmpty.slice(0, -2)}</Alert>
                        <br />
                      </div>
                    }

                    {
                      (fileValidationResult.priceEmpty)
                      &&
                      <div className={paymentStyle.alert}>
                        <Alert severity="error">Add the prices in the following account numbers: {fileValidationResult.priceEmpty.slice(0, -2)}</Alert>
                      </div>
                    }

                    <Box pb={8} />
                    <Grid container justify="space-between">
                      <Button
                        variant="contained"
                        size="large"
                        className={paymentStyle.button}
                        onClick={() => { history.push('payments') }}
                      >
                        Cancel
                       </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        size="large"
                        color="primary"
                        className={paymentStyle.buttonUpload}
                      >
                        Process
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
          <br/>
        </Container>
      </div>

      <div style={{display:'none'}} ref={divResultProcessPayment}>
        <Container maxWidth="lg" className={paymentStyle.ctnUploadFile}>
          <br/>
          <div className={paymentStyle.alert}>
            <Alert severity="success">
              <AlertTitle>File uploaded successfully</AlertTitle>
              {
                (resultProcessPayment.message !== '')
                  &&
                    <strong style={{ color: 'red' }}>{resultProcessPayment.message}</strong>
              }
            </Alert>
          </div>
          <Grid container justify="center">
            <Button
              variant="contained"
              size="large"
              className={paymentStyle.button}
              onClick={() => { history.push('/payments') }}
            >
              Continue
            </Button>
            <Button
              variant="contained"
              size="large"
              color="primary"
              className={paymentStyle.buttonUpload}
              onClick={() => { history.push(`/payment-records/${paymentIdRedirect}`, { id: paymentIdRedirect }) }}
            >
              View records
            </Button>
          </Grid>
        </Container>
      </div>

    </Container>
  );
};

export default CreatePayment;
